import { createComponent } from '@carvana/merch-components';

export const CommonSection = createComponent('section', {
  className:
    'u:mx-auto u:flex u:max-w-[1800px] u:items-center u:justify-center u:bg-background-default u:px-2xl u:py-6xl u:sm:px-3xl u:sm:py-8xl'
});

export const ContentContainer = createComponent('div', {
  className: 'max-w-[504px] sm:max-w-[1272px]'
});

export const CommonHeading = createComponent('h2', {
  className: 'text-text-strong t-heading-2xl md:t-heading-3xl'
});
